export class BackupZeroEtlSingleResourceColumnDefinitionConfig {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "columnDefinitions",
            "baseName": "columnDefinitions",
            "type": "BackupZeroEtlColumnDefinitions",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return BackupZeroEtlSingleResourceColumnDefinitionConfig.attributeTypeMap;
    }
    constructor() {
    }
}
